import type { Product } from 'src/components/restructure/product/types/product'
import { formatterPrice } from 'src/utils/formatterPrice'

import SkuSelector from './SkuSelector'
import { WrapperElement } from './LinkWrapper'

type ProductInfoProps = {
  product: Product
  currentProduct: boolean
  productName: string
  filterList: string[]
  onSelect: React.Dispatch<React.SetStateAction<string | null>>
  selectedSku: string | null | undefined
  listPrice: number
  sellPrice: number
  productLink: { to: string; onClick: () => void; 'data-testid': string }
}

const ProductInfo = ({
  productName,
  listPrice,
  sellPrice,
  product,
  onSelect,
  filterList,
  selectedSku,
  currentProduct,
  productLink,
}: ProductInfoProps) => {
  return (
    <div className="mt-0 md:mt-2 max-w-[192px] md:max-w-full w-full">
      <div className="w-full">
        <WrapperElement
          productLink={productLink}
          enableCardLink={!currentProduct}
        >
          <p className="text-xs text-neutral10 font-medium line-clamp-2">
            {productName}
          </p>
        </WrapperElement>
        <p className="flex flex-wrap items-center gap-1">
          <span className="text-neutral10 text-base font-semibold">
            {formatterPrice(sellPrice)}
          </span>
          {listPrice > sellPrice && (
            <span className="text-[10px] text-redDiscount font-semibold line-through">
              {formatterPrice(listPrice)}
            </span>
          )}
        </p>
      </div>
      <div className=" md:hidden mt-[30px]">
        <SkuSelector
          product={product}
          filters={filterList}
          onSelect={(sku) => onSelect(sku)}
          selectedSku={selectedSku}
        />
      </div>
    </div>
  )
}

export default ProductInfo
